import { useSelector } from "react-redux";
import JobsList from "go-component/components/Job/JobsList";
import { selectOrganization } from "go-security/services/organizations/selectors";

const OrganizationLogsJobsIndexPage = () => {
	const organization = useSelector(selectOrganization);

	return <JobsList organization_name={organization?.name ?? ""} />;
};

export default OrganizationLogsJobsIndexPage;

// t("enums.common.status.STARTED");
